import { palette } from '@livable/saas-react-components';
const MuiSlider = {
  styleOverrides: {
    root: {
      height: '8px',
      borderRadius: '1px',
      '@media (pointer: coarse)': {
        padding: '13px 0'
      }
    },
    rail: {
      backgroundColor: palette.shades[400],
      opacity: '1'
    },
    track: {
      height: '6px',
      backgroundColor: palette.primary.main
    },
    thumb: {
      backgroundColor: palette.primary.dark,
      '&:before': {
        boxShadow: 'none'
      }
    },
    valueLabel: {
      fontFamily: palette.fontFamilies.poppins,
      fontSize: '18px',
      backgroundColor: palette.shades[800],
      padding: '6px 10px'
    },
    mark: {
      backgroundColor: palette.primary.main,
      borderRadius: '0',
      '&.MuiSlider-markActive': {
        backgroundColor: palette.shades[400]
      },
      '&[data-index="0"]': {
        display: 'none'
      },
      // not good
      // '&[data-index="10"]': {
      //   display: 'none',
      // },
      '&:last-child': {
        backgroundColor: 'red'
      }
    }
  }
};
export default MuiSlider;